<template>
    <div>
        <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">Lista eventi</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom v-if="filtri_visible === false">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="mr-5"
                        @click="filtri_visible = true"
                        small
                        v-bind="attrs"
                        v-on="on"
                        ><v-icon color="purple lighten-2"
                            >mdi-filter</v-icon
                        ></v-btn
                    >
                </template>
                <span>Filtri</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="mr-5"
                        @click="
                            filtri_visible = false;
                            gruppo_sel = null;
                            filtra();
                        "
                        small
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon color="purple lighten-2">mdi-filter-off</v-icon>
                    </v-btn>
                </template>
                <span>Ripristina</span>
            </v-tooltip>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-row v-if="filtri_visible === true" align="center" justify="center">
            <v-col cols="3">
                <v-autocomplete
                    background-color="#ffffff"
                    @change="filtra"
                    hide-details
                    :items="gruppi"
                    :item-text="(e) => e.des"
                    item-value="id_tabella"
                    label="Gruppo"
                    style="display: inline-block; max-width: 350px"
                    v-model="gruppo_sel"
                >
                    <template v-slot:append>
                        <v-icon
                            class="ml-2"
                            @click="
                                gruppo_sel = null;
                                filtra();
                            "
                            color="primary"
                            >{{
                                gruppo_sel == null || gruppo_sel == ""
                                    ? "mdi-filter"
                                    : "mdi-filter-off"
                            }}</v-icon
                        >
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="3">
                <v-autocomplete
                    background-color="#ffffff"
                    @change="filtra"
                    hide-details
                    :items="descrizioni"
                    item-text="descrizione"
                    item-value="descrizione"
                    label="Descrizione"
                    style="display: inline-block; max-width: 350px"
                    v-model="filtro_des"
                >
                    <template v-slot:append>
                        <v-icon
                            class="ml-2"
                            @click="
                                filtro_des = null;
                                filtra();
                            "
                            color="primary"
                            >{{
                                filtro_des == null || filtro_des == ""
                                    ? "mdi-filter"
                                    : "mdi-filter-off"
                            }}</v-icon
                        >
                    </template>
                </v-autocomplete>
            </v-col></v-row
        >
        <v-card>
            <v-card-text>
                <v-data-table
                    height="60vh"
                    fixed-header
                    :headers="headers"
                    :items="eventi_vis"
                >
                    <!-- Colonna del modifica -->
                    <template v-slot:[`item.modifica`]="{ item }">
                        <v-btn
                            @click="
                                dialog_modifica_ev = true;
                                selez = item;
                            "
                            small
                            ><v-icon color="primary">mdi-pencil</v-icon></v-btn
                        >
                    </template>

                    <!-- Colonna della data inizio -->
                    <template v-slot:[`item.inizio`]="{ item }">
                        {{ formatData(item.inizio) }}
                    </template>

                    <!-- Colonna della data fine -->
                    <template v-slot:[`item.fine`]="{ item }">
                        {{ formatData(item.fine) }}
                    </template>

                    <!-- Colonna del disattiva -->
                    <template v-slot:[`item.disattiva`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-if="item.status == 1"
                                    @click="disattiva(item)"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    ><v-icon color="error"
                                        >mdi-stop</v-icon
                                    ></v-btn
                                >
                                <v-btn
                                    v-else
                                    @click="attiva(item)"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    ><v-icon color="primary"
                                        >mdi-undo</v-icon
                                    ></v-btn
                                >
                            </template>
                            <span>{{
                                item.status == 1 ? "Disattiva" : "Riattiva"
                            }}</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <!-- Dialog di aggiunta evento -->
        <v-dialog v-model="dialog_modifica_ev" persistent>
            <NuovoModifica
                :key="dialog_modifica_ev"
                @click_chiudi="
                    getEventi();
                    dialog_modifica_ev = false;
                    selez = {};
                "
                @salvataggio_effettuato="getEventi()"
                :nuovo="false"
                :selez="selez"
            />
        </v-dialog>
    </div>
</template>

<script>
import NuovoModifica from "@/components/QNOTICE/NuovoModifica.vue";
import moment from "moment/moment";

export default {
    name: "ListaEventi",
    components: { NuovoModifica },
    props: {},
    data() {
        return {
            descrizioni: [],
            filtro_des: null,
            //Variabili di supporto
            selez: {},
            gruppo_sel: null,

            //Modali
            dialog_modifica_ev: false,
            filtri_visible: false,

            //Array
            eventi: [],
            eventi_vis: [],
            headers: [],
            gruppi: [],
        };
    },

    methods: {
        attiva(evento) {
            const request = {
                controller: "notice",
                method: "PUT",
                richiesta: {
                    action: "saveeventostatus",
                    token: localStorage.user_token,
                    evento: {
                        id_evento: evento.id_evento,
                        status: 1,
                    },
                },
            };

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status === 200) {
                        console.log("Attivato.");
                        this.getEventi();
                    }
                })
                .catch((err) => {
                    // Stampo una snackbar di avviso.
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );

                    // Stampo il log dell'errore in console.
                    console.error(err);
                });
        },

        disattiva(evento) {
            const request = {
                controller: "notice",
                method: "PUT",
                richiesta: {
                    action: "saveeventostatus",
                    token: localStorage.user_token,
                    evento: {
                        id_evento: evento.id_evento,
                        status: 2,
                    },
                },
            };

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status === 200) {
                        console.log("Disattivato.");
                        this.getEventi();
                    }
                })
                .catch((err) => {
                    // Stampo una snackbar di avviso.
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );

                    // Stampo il log dell'errore in console.
                    console.error(err);
                });
        },

        formatData(arg) {
            return arg != null && arg != ""
                ? moment(arg).format("DD-MM-YYYY")
                : "";
        },

        getEventi() {
            console.log("entrato get eventi");
            this.headers = [
                {
                    text: "Modifica",
                    sortable: false,
                    value: "modifica",
                    class: "",
                },

                {
                    text: "Id_evento",
                    value: "id_evento",
                    class: "",
                },
                {
                    text: "Descrizione",
                    value: "descrizione",
                    class: "",
                },
                {
                    text: "Gruppo",
                    value: "gruppo",
                    class: "",
                },
                {
                    text: "Inizio",
                    value: "inizio",
                    class: "",
                },
                {
                    text: "Fine",
                    value: "fine",
                    class: "",
                },
                {
                    text: "Ultima esecuzione",
                    value: "ultima_esecuzione",
                },
                {
                    text: "Cambia stato",
                    value: "disattiva",
                    class: "",
                },
            ];

            var request = {
                controller: "notice",
                method: "POST",
                richiesta: {
                    action: "geteventiall",
                    token: localStorage.getItem("user_token"),
                },
            };

            this.$store
                .dispatch("api6", request)
                .then((res) => {
                    if (res.status == 200) {
                        this.eventi = res.data.result;
                        this.descrizioni = [];
                        for(const e of this.eventi){
                            this.descrizioni.push({descrizione: e.descrizione});
                        }
                    }
                })
                .catch((err) => {
                    console.log("ERRORE");
                    console.log(err);
                });
        },

        filtra() {
            console.log("filtra");
            /*let items_wo_tmp = [];
            this.eventi.forEach((elem) => {
                items_wo_tmp.push(elem);
            });

            console.log(this.gruppo_sel);
            console.log(items_wo_tmp);
            // Filtro il gruppo
            if (this.gruppo_sel != null) {
                let res = [];

                items_wo_tmp.forEach((elem) => {
                    if (elem.id_gruppo == this.gruppo_sel) {
                        console.log(elem.id_gruppo, "-", this.gruppo_sel);
                        res.push(elem);
                    }
                });

                items_wo_tmp = res;
            }

            

            this.eventi_vis = [];
            this.eventi_vis = items_wo_tmp;*/

            this.eventi_vis = this.eventi.filter(
                (e) =>
                    (this.gruppo_sel == null ||
                        e.id_gruppo == this.gruppo_sel) &&
                    (this.filtro_des == null ||
                        e.descrizione == this.filtro_des)
            );
        },

        gettabelle() {
            let request = {
                controller: "Global",
                method: "POST",
                richiesta: {
                    action: "gettabella",
                    token: localStorage.getItem("user_token"),
                    tipo: "NOTICE_GRUPPO",
                    filter: "validita = 1",
                },
            };

            this.$store.dispatch("api", request).then((res) => {
                if (res.status === 200) {
                    this.gruppi = res.data ? res.data : [];
                }
            });
        },
    },

    computed: {},

    watch: {
        eventi: {
            immediate: true,
            handler() {
                this.eventi_vis = this.eventi;
                this.filtra();
            },
        },
    },

    mounted() {
        this.getEventi();
        this.gettabelle();
    },
};
</script>
<style scoped></style>
